import { Box } from '@mui/material';
import React from 'react';

/**
 * Componente de leyenda configurable para mapas
 * @param {string} variant - Tipo de leyenda: 'left' o 'right'
 * @param {Array} customItems - Items personalizados (opcional)
 * @param {string} title - Título personalizado (opcional)
 */
const LegendMap = ({ variant = 'left', customItems = null, selectedModel = null, title = null }) => {
  // Umbrales de densidad por modelo activo
  const densityThresholds = {
    'CNN_HISTORICAL:EU_025_live_demo': {
      light: 1,
      moderate: 50,
      high: 500,
    },
    'CNN_HISTORICAL:EU_01_live_demo': {
      light: 1,
      moderate: 8.0,
      high: 80,
    },
  };

  const defaultThresholds = densityThresholds['CNN_HISTORICAL:EU_025_live_demo'];
  const activeThresholds = densityThresholds[selectedModel] || defaultThresholds;

  // Definir los items según el variant
  const leftItems = [
    { color: '#FFFF00', label: 'Low' },
    { color: '#FF8C00', label: 'Medium' },
    { color: '#E5322D', label: 'High' },
  ];

  const rightItems = [
    { color: '#FFFF00', label: `Low lightning density (>=${activeThresholds.light} counts/km²)` },
    { color: '#FF8C00', label: `Medium lightning density (>${activeThresholds.moderate} counts/km²)` },
    { color: '#E5322D', label: `High lightning density (> ${activeThresholds.high} counts/km²)` },
  ];

  // Seleccionar los items según el variant o usar customItems
  const items = customItems || (variant === 'left' ? leftItems : rightItems);

  const titleText = title || (variant === 'left' ? 'CONVECTIVE RISK' : 'Lightning Density');

  return (
    <Box
      role="group"
      aria-label="Legend"
      // CAMBIO CLAVE: Usamos 'sx' en lugar de 'style'
      sx={{
        position: 'absolute',
        // Ajustamos estos valores para que "bajen"
        bottom: {
          xs: '40px',   // Estaba muy arriba, con 55px queda justo sobre el botón
          lg: '35px',  // Sigue al botón cuando este sube en pantallas grandes
          xl: '40px'
        },
        right: '30px',  // Lo alineamos mejor al borde derecho junto al botón
        background: '#ffffff',
        border: '1px solid rgba(0,0,0,.12)',
        boxShadow: '0 6px 16px rgba(0,0,0,.12)',
        borderRadius: '10px',
        padding: '12px 8px 6px 8px',
        zIndex: 1000,
        pointerEvents: 'none',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '-9px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#e53e3e', // Red badge color matching POLYGONS
          color: '#ffffff',
          padding: '2px 8px',
          borderRadius: '10px',
          fontSize: '0.55rem',
          fontWeight: 'bold',
          letterSpacing: '0.05em',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
          boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
        }}
      >
        {titleText}
      </Box>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {items.map((item) => (
          <li
            key={item.label}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 4,
              fontSize: '0.68rem',
              color: '#0B1220',
              lineHeight: 1,
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: 8,
                height: 8,
                borderRadius: 2,
                marginRight: 6,
                background: item.color,
                border: '1px solid rgba(0,0,0,.45)',
                boxShadow: 'inset 0 0 0 1px rgba(255,255,255,.35)',
                flex: '0 0 auto',
              }}
            />
            <span>{item.label}</span>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default LegendMap;